import axios from 'axios';
import { of, from, BehaviorSubject } from 'rxjs';
import { map, first, filter, debounceTime, distinctUntilChanged, catchError, switchMap } from 'rxjs/operators';

const AUTO_SUGGEST_BASE_URL = `${ process.env.REACT_APP_AOE_SECURE_WITH_PATH }/`;
const BASE_API_CALL_URL = `${ process.env.REACT_APP_AOE_SECURE_WITH_PATH }/api/`;
const AUTO_SUGGEST_DEBOUNCE_TIME = 200;
const DEFAULT_FAILURE_MESSAGE = { response: 'failure', message: '' }; // default failure message.

export const getImpersonationSuggestions = (keyword) => {
   return from(
      axios.get(`${ AUTO_SUGGEST_BASE_URL }impersonation/getEmployers?keyword=${ keyword }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return [];
         }
      }),
      catchError((err) => { return of([]); }),
   );
};

export const impersonationAutoCompleteInput$ = new BehaviorSubject('');
export const impersonationAutoCompleteObservable$ = impersonationAutoCompleteInput$.pipe(
   debounceTime(AUTO_SUGGEST_DEBOUNCE_TIME),
   distinctUntilChanged(),
   filter((input) => input.length > 2),
   switchMap((input) => {
      return getImpersonationSuggestions(input);
   }),
   catchError((err) => { return of([]); }),
);

export const impersonateAsUser = (userEmail) => {
   return from(
      axios.get(`${ BASE_API_CALL_URL }impersonate?username=${ userEmail }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data && response.data.indexOf('success') > -1) {
            return { response: 'success' };
         } else {
            return { response: 'failure' };
         }
      }),
      catchError((err) => { return of({ response: 'failure' }); }),
   );
};

export const backToAdmin = () => {
   return from(
      axios.get(`${ BASE_API_CALL_URL }switchBack`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data && response.data.indexOf('success') > -1) {
            return { response: 'success' };
         } else {
            return { response: 'failure' };
         }
      }),
      catchError((err) => { return of({ response: 'failure' }); }),
   );
};

/*
    Api call to switch Organization for the user.
*/

export const switchOrganization = (organizationId) => {
   if (!organizationId) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Select Organization to switch.' });
   }
   return from(
      axios.get(`${ AUTO_SUGGEST_BASE_URL }/api/user/switch/${ organizationId }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Error switching Organization.' });
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Error switching Organization.' }); }),
   );
};
